import React from "react";
import ReactDOM from "react-dom/client";
import { ChakraProvider, extendTheme } from "@chakra-ui/react";
import "./index.css";
import App from "./App.jsx";

const theme = extendTheme({
  config: {
    initialColorMode: "light",
    useSystemColorMode: false,
  },
  fonts: {
    heading: '"Space Grotesk", sans-serif',
    body: '"IBM Plex Sans", sans-serif',
  },
  colors: {
    brand: {
      50: "#f1f5fb",
      100: "#dbe5f3",
      200: "#b5cbe8",
      300: "#8fb1dd",
      400: "#6a97d2",
      500: "#507db8",
      600: "#3e6290",
      700: "#2b4768",
      800: "#1a2c40",
      900: "#0a121c",
    },
    accent: {
      500: "#d59a2b",
    },
  },
  styles: {
    global: {
      body: {
        bg: "gray.50",
        color: "gray.800",
        backgroundImage:
          "radial-gradient(1200px 500px at 15% -10%, rgba(213, 154, 43, 0.15), rgba(255, 255, 255, 0))," +
          "linear-gradient(180deg, #f8f4ec 0%, #ffffff 60%)",
        _dark: {
          bg: "gray.900",
          color: "gray.100",
          backgroundImage:
            "radial-gradient(1200px 500px at 15% -10%, rgba(80, 125, 184, 0.2), rgba(26, 32, 44, 0))," +
            "linear-gradient(180deg, #111827 0%, #0f172a 65%)",
        },
      },
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ChakraProvider theme={theme}>
      <App />
    </ChakraProvider>
  </React.StrictMode>
);
